// extracted by mini-css-extract-plugin
export default {"page":"wi-z","cartModal":"xi-z","checkout":"yi-z","placeholder":"zi-z","account":"Ai-z"};